import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Column } from '../transaction.interface';
@Component({
  selector: 'app-transactions-table',
  templateUrl: './transactions-table.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './transactions-table.component.scss',
})
export class TransactionsTableComponent implements AfterViewInit, OnChanges {
  @Input() transactions: any[] = [];
  @Input() columns: Column[] = [];

  get displayedColumns(): string[] {
    return this.columns.map((col) => col.key);
  }

  @Output() sort = new EventEmitter<{ column: string; direction: string }>();

  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatSort) matSort!: MatSort;

  constructor(private router: Router) {
    this.dataSource.sortingDataAccessor = (item, property) => {
      // Use the key from the column definition to access the property
      const column = this.columns.find((col) => col.key === property);
      return column ? item[column.key] : item[property];
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['transactions'] && this.matSort) {
      // If transactions data changes and matSort is already initialized, re-apply sort
      this.dataSource.sort = this.matSort;
    }
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.matSort;
  }

  sortData(sort: Sort): void {
    this.sort.emit({ column: sort.active, direction: sort.direction });
  }

  trackByColKey(index: number, col: any): string {
    return col.key;
  }

  openLogDetails(row: any) {
    const stripeId = row.id;
    // sessionStorage.setItem('currentNavName', stripeId);
    this.router.navigate(
      ['/klusup/accounting/payments/stripe/', stripeId],
      // { state: { invoice: rowData } }
    );
  }
}
